const EnterCode = () => {
  return <div>Enter code</div>;
};

export default EnterCode;
